module.exports = __webpack_public_path__ + "static/img/lottery.08817f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/diy/lottery.png
// module id = fKP4
// module chunks = 174